import { AnalyticsService } from '../../../../services/analytics.service';
import { GalleryRecordDialogComponent } from '../gallery-record-dialog/gallery-record-dialog.component';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GalleryRecord, PlantGalleryRecord } from 'shared';
import { NbDialogService } from '@nebular/theme';
import { Subject } from 'rxjs';
import ImageViewer from 'awesome-image-viewer';

@Component({
  selector: 'app-gallery-record-card',
  templateUrl: './gallery-record-card.component.html',
  styleUrls: ['./gallery-record-card.component.scss']
})
export class GalleryRecordCardComponent implements OnInit, OnDestroy {
  @Input() record: GalleryRecord | PlantGalleryRecord | any;

  $destroy = new Subject();

  constructor(private dialogService: NbDialogService, private analyticsService: AnalyticsService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.unsubscribe();
  }

  async viewRecord(): Promise<void> {
    await this.analyticsService.logEvent('view_gallery_record', {
      galleryViewId: this.record.id,
      galleryViewName: this.record.name
    });
    this.dialogService.open(GalleryRecordDialogComponent, {
      hasScroll: true,
      autoFocus: false,
      context: {
        record: this.record
      }
    });
  }

  viewImages() {
    new ImageViewer({
      images: this.record.thumbnails
        .filter((t, index) => {
          // return the large thumb 1024
          return index % 3 === 2;
        })
        .map((photo) => {
          return {
            mainUrl: photo.downloadURL,
            thumbnailUrl: photo.downloadURL,
            description: this.record.name
          };
        })
    });
  }
}
